module.exports = __webpack_public_path__ + "assets/img/Interiors-Australia-Landing-Page-w540.4af37d6a.jpg";